module.exports = __webpack_public_path__ + "staticcomp/img/content_1.9fc7d92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/content_1.jpg
// module id = YYBt
// module chunks = 39